/**
 * Celeste Pawn Color Schemes
 *
 * Gradient-based color schemes for the celeste pawn character design.
 * Each scheme defines color-specific gradients (body, highlights) while
 * neutral colors (eyes, smile, shadow) are shared across all variants.
 */

export interface CelestePawnColorScheme {
  /** Unique name used as gradient ID prefix to avoid SVG collisions */
  name: string;

  /** Back body gradient (dark → medium → darkest) */
  backBody: [string, string, string];

  /** Front body/shirt gradient (bright → light → veryLight) */
  frontBody: [string, string, string];

  /** Flat fill: main body highlight */
  bodyHighlight: string;

  /** Flat fill: face circle */
  faceCircle: string;

  /** Flat fill: front section highlight */
  frontHighlight: string;
}

export const CELESTE_PAWN_COLOR_SCHEMES: Record<string, CelestePawnColorScheme> = {
  blue: {
    name: 'blue',
    backBody: ['#5FACD6', '#4584C7', '#3B57A1'],
    frontBody: ['#72BBFC', '#A7DFFC', '#E6FBFF'],
    bodyHighlight: '#A7DFFC',
    faceCircle: '#70A4EF',
    frontHighlight: '#CEECF4'
  },
  red: {
    name: 'red',
    backBody: ['#D65F5F', '#C74545', '#A13B3B'],
    frontBody: ['#FC7272', '#FCA7A7', '#FFE6E6'],
    bodyHighlight: '#FCA7A7',
    faceCircle: '#EF7070',
    frontHighlight: '#F4CECE'
  },
  yellow: {
    name: 'yellow',
    backBody: ['#D6B85F', '#C7A445', '#A1893B'],
    frontBody: ['#FCDB72', '#FCEAA7', '#FFFBE6'],
    bodyHighlight: '#FCEAA7',
    faceCircle: '#EFD170',
    frontHighlight: '#F4ECCE'
  },
  green: {
    name: 'green',
    backBody: ['#5FD68A', '#45C770', '#3BA15A'],
    frontBody: ['#72FC9E', '#A7FCC4', '#E6FFF0'],
    bodyHighlight: '#A7FCC4',
    faceCircle: '#70EF8E',
    frontHighlight: '#CEF4DC'
  }
};
